export default fn => document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);